<script setup lang="ts">
import CheckBox from '#components/elements/checkBox/CheckBox.vue';
import type { CheckBoxeType } from '#components/elements/checkBox/CheckBoxGroup.vue';
import SortableList from '#components/sortableList/SortableList.vue';

const props = defineProps<{
  modelValue: CheckBoxeType[];
}>();

const emits = defineEmits<{
  'update:modelValue': [CheckBoxeType[]];
}>();

function onCheckBoxChanged(checkbox: CheckBoxeType, checked: boolean) {
  const updatedCheckboxes = props.modelValue.map((item) => {
    if (item.id === checkbox.id) {
      return {
        ...item,
        checked
      };
    }

    return item;
  });

  emits('update:modelValue', updatedCheckboxes);
}
</script>

<template>
  <SortableList :list="modelValue">
    <template #item="checkBox">
      <CheckBox v-bind="checkBox.item" @change="(checked: boolean) => onCheckBoxChanged(checkBox.item, checked)" />
    </template>
  </SortableList>
</template>
